// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zRZJXGC90XmEtTz4EOR_ {
  height: 100%;
  width: 100%;
  position: relative;
  display: block;
}
.nBLgwKzqG8EbYbawds_t {
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: var(--campaign-tab-width);
  margin: 0 auto 10px;
}
.k1EJuJTEkVRAoa67eWne {
  position: relative;
  background-color: #1c1c1e;
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 0;
  width: 100%;
  max-width: var(--campaign-tab-width);
  height: 100%;
  padding: 0;
  margin-bottom: 10px;
  border-radius: 12px;
  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.5);
  border: 1.5px solid #272727;
  box-sizing: border-box;
  overflow: hidden;
}
.k1EJuJTEkVRAoa67eWne[data-players='true'] {
  margin-top: 0;
}
.nvcSfRLHjs4PH6BO2ZJf {
  width: 100%;
  text-align: left;
  font-size: 22px;
  color: #6b7280;
}
.HG5JbJK5rju4McPbTxiT {
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  align-items: center;
  color: white;
  height: 48px;
  padding: 6px 8px;
  border-bottom: 0.5px solid rgba(101, 101, 101, 0.3);
  position: relative;
}
.HG5JbJK5rju4McPbTxiT:last-child {
  border-bottom: none;
}
.hx3B4xqf2pgLCQswszpE {
  display: flex;
  padding: 0.5rem 0;
  font-weight: 400;
  font-family: var(--font-family-primary, inherit);
}
.dtcQE8hQiIcwtF0IcGOV {
  text-align: right;
  padding: 5px 8px;
  font-weight: 400;
  font-family: var(--font-family-primary, inherit);
}
.oIF56hsnda12KkXdZspx {
  font-size: 22px;
  color: #d4d4d4;
  background-color: #212121;
  line-height: normal;
  letter-spacing: normal;
}
.RqnhgoEfzKdCDd9lBeGg {
  width: 30px;
  text-align: center;
}
.dKrgmSpELCwxck7y_D04 {
  padding-left: 10px;
}
@media (max-width: 428px) {
  .dKrgmSpELCwxck7y_D04 {
    padding-left: 0px;
  }
}
.VjzmlOxQ0bohMjCnNaIk {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-height: 60dvh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.l5yhUv44CVVVfs8vf9qO {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 8px auto;
  height: 41dvh;
  background-color: #1c1c1e;
  border-radius: 8px;
  padding: 1rem;
  max-width: 60%;
}
.QB54Z9uKEkGNA6tpw4HB {
  font-size: 16px;
  font-weight: bold;
  line-height: 19.2px;
  color: #ffdf1a;
}
.s2g2vRnB0X4BMAuZY7BR {
  color: var(--campaign-color-text-grey);
  font-size: 1.125rem;
  font-weight: 500;
  text-align: center;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .nvcSfRLHjs4PH6BO2ZJf {
    font-size: 15px;
  }
  .oIF56hsnda12KkXdZspx {
    font-size: 15px;
    height: 32px;
  }
  .HG5JbJK5rju4McPbTxiT {
    height: 32px;
    padding: 16px 5px;
  }
  .l5yhUv44CVVVfs8vf9qO {
    max-width: 95%;
  }
}
@media (orientation: portrait) {
  .nBLgwKzqG8EbYbawds_t {
    width: 100%;
  }
  .k1EJuJTEkVRAoa67eWne {
    width: 100%;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (orientation: portrait) and (max-color:2147477350) {
  .k1EJuJTEkVRAoa67eWne,
  .l5yhUv44CVVVfs8vf9qO {
    border-radius: 8px;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (orientation: portrait) and (color:2147477350) {
  .k1EJuJTEkVRAoa67eWne,
  .l5yhUv44CVVVfs8vf9qO {
    border-radius: 8px;
  }
}
}
}
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/variants/tournaments/tabs/RankingTab/TournamentRankingTab.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,MAAM;EACN,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,2BAA2B;EAC3B,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,mDAAmD;EACnD,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,gDAAgD;AAClD;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gDAAgD;AAClD;AACA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF;AACA;AAAA;EACE;;IAEE,kBAAkB;EACpB;AACF;AAAA;AALA;AAAA;AAAA;AAAA;EACE;;IAEE,kBAAkB;EACpB;AACF;AAAA;AAAA;AAAA","sourcesContent":[".loaderContainer {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  display: block;\n}\n.tableWrapper {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  max-width: var(--campaign-tab-width);\n  margin: 0 auto 10px;\n}\n.tableContainer {\n  position: relative;\n  background-color: #1c1c1e;\n  display: flex;\n  justify-content: center;\n  align-items: stretch;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  gap: 0;\n  width: 100%;\n  max-width: var(--campaign-tab-width);\n  height: 100%;\n  padding: 0;\n  margin-bottom: 10px;\n  border-radius: 12px;\n  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.5);\n  border: 1.5px solid #272727;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n.tableContainer[data-players='true'] {\n  margin-top: 0;\n}\n.tableWrapperInner {\n  width: 100%;\n  text-align: left;\n  font-size: 22px;\n  color: #6b7280;\n}\n.tableRow {\n  display: flex;\n  flex-grow: 1;\n  justify-content: space-between;\n  align-items: center;\n  color: white;\n  height: 48px;\n  padding: 6px 8px;\n  border-bottom: 0.5px solid rgba(101, 101, 101, 0.3);\n  position: relative;\n}\n.tableRow:last-child {\n  border-bottom: none;\n}\n.tableHeaderCell {\n  display: flex;\n  padding: 0.5rem 0;\n  font-weight: 400;\n  font-family: var(--font-family-primary, inherit);\n}\n.genericPointsCell {\n  text-align: right;\n  padding: 5px 8px;\n  font-weight: 400;\n  font-family: var(--font-family-primary, inherit);\n}\n.tableHeaderRow {\n  font-size: 22px;\n  color: #d4d4d4;\n  background-color: #212121;\n  line-height: normal;\n  letter-spacing: normal;\n}\n.playerSimbol {\n  width: 30px;\n  text-align: center;\n}\n.playerCount {\n  padding-left: 10px;\n}\n@media (max-width: 428px) {\n  .playerCount {\n    padding-left: 0px;\n  }\n}\n.tableBody {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  max-height: 60dvh;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n}\n.noDataWrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin: 8px auto;\n  height: 41dvh;\n  background-color: #1c1c1e;\n  border-radius: 8px;\n  padding: 1rem;\n  max-width: 60%;\n}\n.highlightedText {\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 19.2px;\n  color: #ffdf1a;\n}\n.noDataText {\n  color: var(--campaign-color-text-grey);\n  font-size: 1.125rem;\n  font-weight: 500;\n  text-align: center;\n}\n@media (--campaign-mobile) {\n  .tableWrapperInner {\n    font-size: 15px;\n  }\n  .tableHeaderRow {\n    font-size: 15px;\n    height: 32px;\n  }\n  .tableRow {\n    height: 32px;\n    padding: 16px 5px;\n  }\n  .noDataWrapper {\n    max-width: 95%;\n  }\n}\n@media (orientation: portrait) {\n  .tableWrapper {\n    width: 100%;\n  }\n  .tableContainer {\n    width: 100%;\n  }\n}\n@media (orientation: portrait) and (--campaign-mobile) {\n  .tableContainer,\n  .noDataWrapper {\n    border-radius: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loaderContainer": `zRZJXGC90XmEtTz4EOR_`,
	"tableWrapper": `nBLgwKzqG8EbYbawds_t`,
	"tableContainer": `k1EJuJTEkVRAoa67eWne`,
	"tableWrapperInner": `nvcSfRLHjs4PH6BO2ZJf`,
	"tableRow": `HG5JbJK5rju4McPbTxiT`,
	"tableHeaderCell": `hx3B4xqf2pgLCQswszpE`,
	"genericPointsCell": `dtcQE8hQiIcwtF0IcGOV`,
	"tableHeaderRow": `oIF56hsnda12KkXdZspx`,
	"playerSimbol": `RqnhgoEfzKdCDd9lBeGg`,
	"playerCount": `dKrgmSpELCwxck7y_D04`,
	"tableBody": `VjzmlOxQ0bohMjCnNaIk`,
	"noDataWrapper": `l5yhUv44CVVVfs8vf9qO`,
	"highlightedText": `QB54Z9uKEkGNA6tpw4HB`,
	"noDataText": `s2g2vRnB0X4BMAuZY7BR`
};
export default ___CSS_LOADER_EXPORT___;
